import React from 'react';

const HowItWorks = () => {
  return (
    <section id="como-funciona" className="bg-white py-8 pb-16">
      <div className="container-max px-6 sm:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-16">
            Cómo funciona en 3 simples pasos
          </h2>
          
          <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
            {/* Paso 1 */}
            <div className="text-center">
              <div className="w-16 h-16 bg-primary-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-white">1</span>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-4">
                Describe tu clase
              </h3>
              <p className="text-sm sm:text-base text-gray-600">Elige tu materia y nivel</p>
            </div>
            
            {/* Paso 2 */}
            <div className="text-center">
              <div className="w-16 h-16 bg-secondary-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-white">2</span>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-4">
                Tareia genera la actividad
              </h3>
              <p className="text-sm sm:text-base text-gray-600">Genera actividades automáticamente</p>
            </div>
            
            {/* Paso 3 */}
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-white">3</span>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-4">
                Imprime y usa
              </h3>
              <p className="text-sm sm:text-base text-gray-600">Úsalas en clase o compártelas</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;